import React from 'react'
import PropTypes from 'prop-types'

import { NORMAL, DISTRESS } from 'app/constants/statusColors'

const StatusIcon = (props) => {
  const { type } = props

  const handleColor = (type) => {
    switch (type) {
      case NORMAL:
        return (
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect y="0.5" width="16" height="16" rx="4" fill="#22C55E" />
            <path
              d="M6.69332 11.7063L3.65332 8.6663L4.41332 7.9063L6.69332 10.1863L11.5867 5.29297L12.3467 6.05297L6.69332 11.7063Z"
              fill="white"
            />
          </svg>
        )

      case DISTRESS:
        return (
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect y="0.5" width="16" height="16" rx="4" fill="#F59E0B" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.95096 4.60226L7.4342 3.60896C7.79741 3.46368 8.20259 3.46368 8.5658 3.60896L11.049 4.60226C11.4362 4.7571 11.7429 5.06384 11.8977 5.45096L12.891 7.9342C13.0363 8.29741 13.0363 8.70259 12.891 9.0658L11.8977 11.549C11.7429 11.9362 11.4362 12.2429 11.049 12.3977L8.5658 13.391C8.20259 13.5363 7.79741 13.5363 7.4342 13.391L4.95096 12.3977C4.56384 12.2429 4.2571 11.9362 4.10226 11.549L3.10896 9.0658C2.96368 8.70259 2.96368 8.29741 3.10896 7.9342L4.10226 5.45096C4.2571 5.06384 4.56384 4.7571 4.95096 4.60226ZM5.13956 5.07376L7.6228 4.08047C7.86494 3.98361 8.13506 3.98361 8.3772 4.08047L10.8604 5.07376C11.1185 5.17699 11.323 5.38148 11.4262 5.63956L12.4195 8.1228C12.5164 8.36494 12.5164 8.63506 12.4195 8.8772L11.4262 11.3604C11.323 11.6185 11.1185 11.823 10.8604 11.9262L8.3772 12.9195C8.13506 13.0164 7.86494 13.0164 7.6228 12.9195L5.13956 11.9262C4.88148 11.823 4.67699 11.6185 4.57376 11.3604L3.58047 8.8772C3.48361 8.63506 3.48361 8.36494 3.58047 8.1228L4.57376 5.63956C4.67699 5.38148 4.88148 5.17699 5.13956 5.07376Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 11.0391C7.71954 11.0391 7.49218 10.8118 7.49218 10.5313C7.49218 10.2508 7.71954 10.0235 8 10.0235C8.28046 10.0235 8.50782 10.2508 8.50782 10.5313C8.50782 10.8118 8.28046 11.0391 8 11.0391Z"
              fill="white"
            />
            <path
              d="M8.50782 9.00782C8.50782 9.28829 8.28046 9.51565 8 9.51565C7.71954 9.51565 7.49218 9.28829 7.49218 9.00782L7.49218 6.4687C7.49218 6.18824 7.71954 5.96088 8 5.96088C8.28046 5.96088 8.50782 6.18824 8.50782 6.4687L8.50782 9.00782Z"
              fill="white"
            />
          </svg>
        )

      default:
        return
    }
  }

  return <div className="flex">{handleColor(type)}</div>
}

StatusIcon.propTypes = {
  type: PropTypes.string.isRequired,
}

export default StatusIcon
